import { render } from "./PhotoStats.vue?vue&type=template&id=6209d4dc&scoped=true"
import script from "./PhotoStats.vue?vue&type=script&lang=js"
export * from "./PhotoStats.vue?vue&type=script&lang=js"

import "./PhotoStats.vue?vue&type=style&index=0&id=6209d4dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6209d4dc"]])

export default __exports__